import moment from 'moment-timezone';

angular.module('logbook')
	.directive('scheduledReportManager', ['$http', '$location', '$rootScope', '$uibModal', function($http, $location, $rootScope, $uibModal) {
		return {
			template: require('app/reports/scheduled-report-manager.html'),
			link: {
				pre: function(scope) {
					scope.scheduledReports = [];
					scope.srcScheduledReports = [];
					scope.runMap = {};
					
					scope.fetchScheduledReports = () => {
						return $http.get('/api/scheduledReports', {
							params: {
								'report.log': $rootScope.selectedLog.id
							}
						})
							.then((results) => results.data._embedded.scheduledReports);
					}
					
					scope.filterSameReports = (reports) => {
						if (!Array.isArray(reports)) return [];
						
						const createRunEntry = (scReport) => {
							if (!scReport)
								return {
									status: true,
									when: null
								}
							else
								return {
									status: (typeof scReport.lastRunStatus === 'boolean') ? scReport.lastRunStatus : true,
									when: scReport.lastRun
								}
						}
						
						return reports.reduce((map, report) => {
							const details = (map[report.report.id])
								? map[report.report.id]
								: map[report.report.id] = { lastRun: createRunEntry(), report: null };
							
							const _report = details.report;
							let lastRun = details.lastRun;
							
							if (!_report)
							{
								details.report = report;
								details.lastRun = createRunEntry(report);
							}
							else {
								details.report = moment(_report.nextExecution).diff(report.nextExecution) > 0
									? report
									: _report;
								
								if (lastRun.when && report.lastRun) {
									if ( moment(lastRun.when).diff(report.lastRun) < 0 )
										details.lastRun = createRunEntry(report);
								}
								
								else if (report.lastRun)
									details.lastRun = createRunEntry(report);
							}
							
							return map;
						}, {});
					}
					
					scope.updateScheduledReports = () => {
						return scope.fetchScheduledReports()
							.then(reports => {
								const map = scope.filterSameReports(reports);
								const reportArr = [];
								scope.runMap = {};
								
								Object.keys(map).forEach(key => {
									reportArr.push(map[key].report);
									scope.runMap[key] = map[key].lastRun;
								})
								
								scope.scheduledReports = reportArr;
								scope.srcScheduledReports = Array.from(reportArr);
							});
					}
					
					scope.goToReport = (complexId) => {
						$location.url('report-editor')
							.search('draft', complexId);
					}
					
					scope.viewUsers = (scReport) => {
						$uibModal.open({
							template: require('app/shared/modals/users-modal.html'),
							controller: ['$scope', function($scope)
							{
								$scope.title = `Users for report ${scReport.reportName}`
								$scope.users = scReport.notifyUsers;
							}]
						})
					}
				},
				
				post: function(scope) {
					scope.updateScheduledReports();
				}
			}
		}
	}])